 <template>
  <v-expansion-panels
    style="background-color: #eee; margin-top: 10px; z-index: 0"
  >
    <v-expansion-panel>
      <v-expansion-panel-header style="background-color: #eee;">
        <div>
          <v-icon>mdi-file</v-icon>
          <b style="font-size: 14px; font-weight: 600; padding-left: 10px">
            {{ index.replace("FILE_", "") }}
          </b>
        </div>

        <div v-if="!isNew">
          <b
            >{{ value.value.name }} ({{ Math.ceil(value.value.size / 1024) }} Kb)</b
          >
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>

        <v-card style="background-color: #eee;margin-top:15px" v-if="isNew && !editMode">
          <v-card-text class="text-h5 font-weight-bold">
            <core-file-upload ref="fileUpload" @input="storeImage" label="Trascina qua il file che vuoi caricare"/>
          </v-card-text>
        </v-card>


        <v-card style="background-color: #eee;margin-top:15px" v-if="!isNew">
          <v-card-text class="text-h5 font-weight-bold">
            <a :href="imgPath">Download</a>
          </v-card-text>
          <v-card-actions>
            <v-btn small color="lighten-2 warning" @click="deleteFile">
              <v-icon small>mdi-delete</v-icon>
              Remove File
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
 
<script>
let { post } = require("@/api/base_entity");
import { mapActions } from 'vuex'

export default {
  props: {
    value: { type: Object },
    index: { type: String, default: "" },
    entityId: { type: Number },
    entity: { type: String },
  },
  data() {
    return {
      base64: null,
      image: {
        entity: this.entity,
        entity_id: this.entityId
      },
      imgHeight: 320,
      imgWidth: 480,
      loadingStore: false,
      editMode: false
    };
  },
  watch: {
  },
  mounted() {
     this.getConfig()
  },
  computed: {
    isNew() {
      return !this.value.value;
    },
    imgPath() {
      return (
        // this.$store.getters.s3BaseUrl +
        this.$store.getters.siteUrl + 
        this.$store.getters.staticFileUrl + '/' +
        this.value.value.uuid +
        this.value.value.extension
      );
    },
  },
  methods: {
    ...mapActions('app', ['getConfig']),
    onFileInfo(info) {
      this.image = info
      this.image.entity = this.entity
      this.image.entity_id = this.entityId
    },
    onInput(base64) {
      this.image.base64 = base64;
    },
    storeImage(val) {

      if(val.base64) {
        this.image = {
          'lastModified': val.lastModified,
          'name': val.name,
          'size': val.size,
          'type': val.type,
          'base64': val.base64,
          'entity': this.entity,
          'entity_id': this.entityId
        } 
      }

      this.loadingStore = true;
      
      return post("file", this.image)
        .then((ret) => {
          this.value.value = ret.data;
          this.$root.$emit('openSnackbar', {
            message: 'File caricato con successo!',
            color: 'success'
          })
          this.$refs.fileUpload.setBusy(false)
        }).
        catch( (msg) => {
          this.$root.$emit('openSnackbar', {
            message: 'Si è verificato un errore durante il caricamento del file : ' + msg.response.data.message || 'Error',
            color: 'error'
          })
        })
        .finally(() => {
          this.loadingStore = false;
        });
        
    },
    deleteFile() {
      this.value.value = null;
      this.image = null
      this.base64 = null
    },
  },
};
</script>
 
 <style>
.imageComponent {
  background-color: rgb(102, 102, 102);
}
</style>